module.exports = __webpack_public_path__ + "img/murloc_village_small.1ec30cbd.png";